{
  "topMenu": {
    "dihTitle": "数据智能中心",
    "dihSubTitle": "安全地从数据中提取价值",
    "logout": "登出",
    "dihPortal": "DIH 门户",
    "cofinityDataspace": "数据空间门户",
    "portal": "门户网站"
  },
  "userLogoutAlert": {
    "title": "您确定要登出吗？",
    "back": "返回",
    "logout": "登出"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "首页",
    "collapse": "收起侧边栏",
    "help": "帮助",
    "prepare": "模型管理",
    "model": "数据模型",
    "mapping": "数据映射",
    "converter": "数据转换器",
    "provide": "提供",
    "publishData": "发布数据",
    "assets": "资产",
    "policyPublicationTemplate": "政策发布模板",
    "uploadHistory": "资产上传历史",
    "consume": "消费",
    "searchDataOffers": "搜索数据优惠",
    "simulateDataOffers": "模拟数据优惠",
    "negotiatedDataOffers": "已协商的数据优惠",
    "downloadHistory": "资产下载历史",
    "govern": "治理",
    "myPolicies": "我的政策",
    "createPolicies": "创建政策",
    "policyTemplate": "政策模板",
    "manageAndConfig": "配置",
    "connections": "管理连接器",
    "jobs": "处理日志",
    "monitoring": "监控",
    "licences": "许可证",
    "contractAgreements": "合同协议",
    "providedAgreements": "提供的合同协议",
    "incomingAgreements": "传入的数据优惠",
    "consumedAgreements": "消费的合同协议",
    "consumeAutomation": "消费政策自动化",
    "networkAnalytics": "网络分析",
    "otherLogs": "其他日志",
    "digitalTwin": "数字孪生浏览器",
    "messagesBrowserInbound": "入站消息",
    "messagesBrowserOutbound": "出站消息",
    "applications": "应用程序",
    "electronicControlUnit": "电子控制单元",
    "pcfExchange": "PCF 交换 (Jupiter)",
    "pcfExchangeV9": "PCF 交换 (Saturn)",
    "pcfRequests": "PCF 数据请求",
    "pcfExchangeHistory": "PCF 数据交换历史",
    "pcfExchangeV9History": "PCF v9 数据交换历史",
    "publicationTemplates": "发布模板",
    "certificateManagement": "证书管理",
    "certificates": "证书",
    "connectors": "我的连接器",
    "contractDefinitions": "我的合同定义"
  },
  "workspace": {
    "rail": {
      "label": "主导航",
      "home": "首页",
      "apps": "应用",
      "advanced": "高级",
      "help": "帮助"
    },
    "apps": {
      "title": "当前工作区",
      "none": "未选择工作区",
      "search": "搜索",
      "close": "关闭",
      "comingSoon": "即将推出",
      "noResults": "未找到匹配的应用。",
      "names": {
        "certificateManagement": "证书管理",
        "pcfJupiter": "产品碳足迹 Jupiter",
        "pcfSaturn": "产品碳足迹 Saturn",
        "blockNotifications": "阻断通知",
        "traceability": "可追溯性",
        "cyberSecurityMetrics": "网络安全指标",
        "electronicControlUnit": "电子控制单元",
        "batteryPassport": "电池护照",
        "simpleFileExchange": "简单文件交换",
        "advanced": "高级"
      }
    },
    "menu": {
      "groups": {
        "overview": "概览",
        "provide": "提供",
        "consume": "消费",
        "history": "历史记录",
        "notifications": "通知",
        "diagnostics": "诊断",
        "pcfRequests": "PCF 请求",
        "pcfCalculation": "PCF 计算",
        "ecuMessages": "ECU 消息",
        "governance": "治理",
        "data": "数据",
        "connections": "连接",
        "operationsDiagnostics": "运营与诊断",
        "digitalTwins": "数字孪生"
      },
      "items": {
        "dashboard": "仪表板",
        "userGuide": "用户指南和教程",
        "developerDocumentation": "开发者文档",
        "publishCertificate": "发布证书",
        "myCertificates": "我的证书",
        "sharedCertificates": "共享的证书",
        "mySites": "我的站点",
        "discoverCertificates": "发现证书",
        "downloadCertificates": "下载证书",
        "consumptionHistory": "消费历史",
        "messagesLog": "消息日志",
        "createPcfOffer": "创建 PCF 产品",
        "discoverPcf": "发现并请求 PCF 数据",
        "pcfAspects": "PCF 方面",
        "pcfDataRequests": "PCF 数据请求",
        "pcfExchangeHistory": "PCF 交换历史",
        "pcfCalculator": "PCF 计算器",
        "sendBlockNotifications": "发送阻断通知",
        "receivedBlockNotifications": "收到的阻断通知",
        "sentNotificationsHistory": "已发送通知历史",
        "receivedNotificationsHistory": "已接收通知历史",
        "createTraceabilityOffer": "创建可追溯性产品",
        "createQualityAlert": "创建质量警报或调查",
        "discoverTraceability": "发现可追溯性数据",
        "industryCoreNotifications": "Industry Core 通知",
        "traceabilityNotifications": "可追溯性通知",
        "exchangeHistory": "交换历史",
        "contractAgreements": "合同协议",
        "createSendMetrics": "创建并发送指标",
        "receiveViewMetrics": "接收并查看指标",
        "ecuAssets": "ECU 资产",
        "outgoingMessages": "发出的消息",
        "incomingMessages": "接收的消息",
        "processLogs": "流程日志",
        "apiPollingLogs": "API 轮询日志",
        "myPolicies": "我的策略",
        "myContractAgreements": "我的合同协议",
        "myContractDefinitions": "我的合同定义",
        "myAssets": "我的资产",
        "simulateDataOffers": "模拟数据优惠",
        "myConnectors": "我的连接器",
        "externalConnectionManagement": "外部连接管理",
        "twinBrowserProvider": "孪生浏览器 - 提供方",
        "twinBrowserConsumer": "孪生浏览器 - 消费方",
        "switchApplication": "切换应用程序"
      }
    }
  },
  "versionModal": {
    "title": "一般信息",
    "error": "无法获取版本详细信息",
    "table": {
      "title": "组件详细信息",
      "componentName": "组件名称",
      "imageVersion": "镜像版本",
      "chartVersion": "图表版本"
    }
  },
  "dropdown": {
    "selectAll": "全选",
    "noOption": "没有可用选项",
    "noSuchOption": "没有此选项...",
    "selectConnection": "选择连接"
  },
  "certificateManagement": {
    "title": "业务合作伙伴证书管理",
    "description": "欢迎使用 Catena-X 中便捷的端到端业务合作伙伴证书交换解决方案。",
    "howTo": {
      "description": "探索其他 Catena-X 成员公司的数据产品目录。您可以搜索、选择并订阅证书产品，也可以通过公司名称进行搜索。",
      "doc": "想了解业务合作伙伴证书管理是如何运作的吗？"
    },
    "landingTiles": {
      "tile_1": {
        "title": "发布证书",
        "description": "在 Catena-X 网络中创建和共享您的站点证书。"
      },
      "tile_2": {
        "title": "发现并使用证书",
        "description": "轻松搜索和下载网站及商业证书。"
      },
      "tile_3": {
        "title": "证书发布历史",
        "description": "您提供的所有证书概览"
      },
      "tile_4": {
        "title": "已使用证书历史",
        "description": "您已使用的所有证书概览"
      },
      "tile_5": {
        "title": "传入的证书请求",
        "description": "传入的共享证书请求概览"
      },
      "tile_6": {
        "title": "传出的证书状态",
        "description": "用于共享证书的操作概览"
      },
      "tile_7": {
        "title": "请求证书",
        "description": "轻松搜索和下载网站及商业证书。"
      }
    },
    "recentCertificateRequests": "最近的传入证书数据请求",
    "learnMore": "了解更多关于证书管理的信息",
    "pushCertificate": "推送证书",
    "pushDescription": "现有证书将共享给下方所选的合作伙伴。请注意，将应用与原始要约中相同的政策。如果您希望更改政策，请创建一个新的数据要约。",
    "requestCertificates": "请求新证书",
    "pushSuccess": "证书推送过程已启动！作业 ID 为 {id}",
    "receiverBpn": "接收器 BPN",
    "providerBpn": "供应商 BPN",
    "locationBpns": "站点 BPNA/BPNS",
    "certificateType": "证书类型",
    "requestSuccess": "已成功提交证书请求",
    "pushResult": "{total}个{status}请求中有{successful}个成功",
    "receiveConfirmTitle": "确认接收证书",
    "receiveConfirmDesc": "点击“是”即表示您确认已收到合作伙伴共享的证书。提供方将收到您的确认。接下来，您可以接受或拒绝该证书。",
    "acceptedConfirmTitle": "接受证书",
    "acceptedConfirmDesc": "点击“是”即表示您接受该证书符合预期。您可以点击查看图标将证书下载为 PDF。",
    "rejectedConfirmTitle": "拒绝证书",
    "rejectedConfirmDesc": "点击“是”即表示您拒绝接收到的证书。提供方将收到拒绝通知。他们可以重新分享，或者您可以再次请求新证书。",
    "processStarted": "'{type}' 流程已开始！任务编号是 {id}",
    "certificateDetails": "证书详情",
    "availableCertificate": "可用证书位置",
    "updateSuccess": "证书成功更新了！",
    "updateFailure": "证书更新失败！",
    "wizard": {
      "selectCompanies": "选择公司",
      "selectPolicies": "选择政策"
    },
    "step1Description": "选择一个或多个公司来共享证书。",
    "step2Description": "选择证书共享的策略。",
    "noPoliciesFound": "没有找到适用于所选公司的政策。",
    "policiesFound": "找到 {count} 条政策",
    "selectedPolicies": "已选择 {count} 个",
    "policyName": "保单名称",
    "bpn": "巴布亚新几内亚",
    "policyType": "类型",
    "errorFetchingPolicies": "获取策略失败。",
    "assetId": "资产ID",
    "noPoliciesFoundInCatalog": "在目录中找不到所选公司的政策。",
    "duplicateBpnError": "您不能两次选择同一个BPN。",
    "membershipValue": "会员资格",
    "contractReference": "合同参考",
    "connectorEndpoint": "连接器端点",
    "noCompatibleOfferPush": "未找到兼容CCM-Push的报价。请联系您选择的商业伙伴发布一个。",
    "noCompatibleOfferAvailable": "未找到兼容CCM-Available的报价。请联系您选择的商业伙伴发布一个。",
    "certificateDownload": {
      "downloadReceivedJson": "下载接收到的 JSON",
      "downloadCertificatePdf": "下载证书 PDF"
    }
  },
  "common": {
    "start": "开始",
    "firstName": "名字",
    "lastName": "姓氏",
    "email": "电子邮件地址",
    "phoneNumber": "电话号码",
    "contactPerson": "联系人",
    "welcome": "欢迎",
    "street": "街道",
    "city": "城市",
    "country": "国家",
    "postCode": "邮政编码",
    "number": "号码",
    "next": "下一步",
    "prev": "返回",
    "alreadyAccount": "已有账户？",
    "login": "登录",
    "loginNow": "立即登录",
    "register": "注册",
    "home": "首页",
    "submit": "提交",
    "attention": "注意",
    "desc": "描述",
    "website": "网站",
    "contact": "联系",
    "details": "详情",
    "plan": "计划",
    "table": "表格",
    "grid": "网格",
    "listView": "列表视图",
    "gridView": "网格视图",
    "firstPage": "到第一页",
    "previousPage": "到上一页",
    "nextPage": "到下一页",
    "lastPage": "到最后一页",
    "paginationUnknownButton": "未知的分页按钮类型",
    "download": "下载",
    "delete": "删除",
    "edit": "编辑",
    "information": "信息",
    "organization": "组织",
    "cancel": "取消",
    "save": "保存",
    "upload": "上传",
    "link": "链接",
    "view": "查看",
    "search": "搜索",
    "selectOption": "选择一个选项",
    "sortBy": "排序方式",
    "dataspace": "数据空间",
    "select": "选择",
    "date": "日期",
    "title": "标题",
    "back": "返回",
    "startTyping": "开始输入",
    "useCases": "用例",
    "done": "完成",
    "enterValue": "输入值",
    "selectValue": "选择值",
    "selectDate": "选择日期",
    "selectYear": "选定年份",
    "refresh": "刷新",
    "searchByName": "按名称搜索",
    "close": "关闭",
    "copyToClipboard": "已复制到剪贴板！",
    "enterKeyName": "输入键名",
    "fileDownloadSuccess": "文件下载成功",
    "fileDownloadError": "文件下载失败",
    "certificate": "证书",
    "manageConnections": "管理连接",
    "confirm": "确认",
    "yes": "是",
    "no": "否",
    "connectionDetails": "{type}连接详细信息",
    "hide": "隐藏",
    "unpublish": "未出版",
    "clear": "清除",
    "viewAll": "查看全部",
    "apply": "申请",
    "from": "从",
    "to": "到",
    "isRequired": "是必须的",
    "confirmationRequired": "请勾选此框进行确认",
    "send": "发送",
    "update": "更新",
    "createSend": "创建并发送",
    "share": "分享",
    "recentRequests": "最近的请求",
    "severity": "严重程度",
    "expectedResponseBy": "预期响应",
    "active": "启用",
    "viewDocs": "查看文档",
    "request": "请求",
    "noData": "无数据",
    "provided": "已提供",
    "consumed": "已消费",
    "autosaving": "自动保存中",
    "connectIntegrate": "Connect & Integrate"
  },
  "genericError": "哦，出了点问题！请重试。",
  "validation": {
    "fieldRequired": "{field} 是必填项。",
    "fieldNumeric": "字段 {field} 只能包含数字。",
    "fieldAlpha": "字段 {field} 只能包含字母、_ 和 -。",
    "fieldAlphanumeric": "字段 {field} 只能包含字母、数字、_ 和 -。",
    "fieldNumericDash": "字段 {field} 只能包含数字和 -。",
    "fieldHouseNumber": "字段 {field} 只能包含数字、字母以及字符 - 和 /。",
    "fieldPhoneNumber": "字段 {field} 只能包含数字和 -，必须以 + 或 00 开头。",
    "fieldAlphaDash": "字段 {field} 只能包含字母和 -。",
    "exceptHTMLTagBrackets": "字段 {field} 不得包含以下字符：^<>",
    "isMaxLength": "超出最大长度 10 个字符。",
    "emailFormat": "电子邮件地址格式错误",
    "fileSizeError": "文件大小超过 {size} MB。",
    "csvFileSizeError": "文件过大。您可以上传最大 {size} MB 的文件。",
    "csvFileExtensionError": "仅允许上传 csv 扩展名的文件。",
    "csvFileIsEmptyError": "文件为空。您需要上传至少 {size} KB 的文件。",
    "csvFileFormatError": "文件格式不符合预期。请使用提供的模板重试。",
    "uploadFails": "上传失败",
    "fileExtensionError": "文件扩展名不合适",
    "fileIsMalwareInfectedError": "此文件似乎包含恶意软件。出于安全原因，无法上传此文件。请再次检查您的文件。",
    "customValidation": "{field} 格式错误。",
    "selectCountryFirst": "请先选择国家名称",
    "validationPostCodeCaseDE": "字段格式错误。必须包含 5 位数字，例如 53113",
    "validationAlphanumericCase": "字段只能包含字母、数字、破折号和下划线。值必须以字母或数字开头。",
    "validationNumericDashCase": "字段只能包含数字和 -。",
    "url": "请输入有效的 URL",
    "required": "此字段为必填项",
    "password": {
      "passwordStrength": "密码强度",
      "weak": "弱",
      "average": "中等",
      "strong": "强",
      "passwordValidationMoreChar": "{count} 个或更多字符",
      "passwordUpperAndLowerChar": "大小写字母",
      "passwordAtLeastNumber": "至少一个数字",
      "passwordAtLeastSpecialChar": "至少一个特殊字符（除了 <>&\"`[]）",
      "passwordDiffFromPrev": "与之前的密码不同"
    }
  },
  "footer": {
    "tagLine": "让我们助力更高的性能",
    "imprint": "法律声明",
    "imprintShort": "声明",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "联系我们",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "条款与条件",
    "privacy": "隐私政策",
    "privacyShort": "隐私",
    "telekom": "T-Systems International GmbH。保留所有权利。",
    "telekomShort": "T-Systems 国际有限公司",
    "note": "电信数据智能中心 - 仅限商业客户",
    "brandedNote": "由电信数据智能中心提供支持",
    "cookieSettings": "Cookie 设置",
    "cookieSettingsShort": "曲奇饼",
    "life": "生活因分享而精彩"
  },
  "cookieSettings": {
    "collapsedTitle": "隐私设置",
    "collapsedText": "本网站使用 cookies 和类似技术。这些是存储和读取您计算机上的小文本文件。通过点击“{0}”，您同意处理、跨网站和合作伙伴创建个人用户档案，以及将您的数据传输给第三方，其中一些第三方在欧盟以外的国家（GDPR 第 49 条）处理您的数据。详情请见{1}的第 2 节。数据用于分析、重新定位以及在电信网站和第三方网站上播放个性化内容和广告。更多信息，包括第三方提供商的数据处理信息和撤销的可能性，请见设置和我们的隐私信息。在此您可以{2}仅使用必要的工具。",
    "extendedTitle": "隐私设置",
    "extendedText": "为了为您提供最佳的网站体验，我们使用 cookies。这些包括用于网站操作和优化的 cookies，以及基于您的在线使用行为的服务（如文本或视频聊天）和广告。这使我们能够例如检测您是否从同一设备重复访问我们的页面。我们希望您可以选择允许哪些 cookies：",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "隐私信息",
    "policyLinkText": "隐私信息",
    "rejectLinkText": "继续",
    "acceptButton": "接受所有",
    "saveButton": "保存设置",
    "settingsButton": "更改设置",
    "showMore": "显示更多",
    "showLess": "显示更少",
    "categoryTitleEssential": "必要 cookies",
    "categoryTitleAnalytics": "分析 cookies",
    "categoryTitleMarketing": "营销 cookies",
    "categoryTitleThirdParty": "第三方服务（独立第三方提供商）",
    "categoryTextEssential": "这些 cookies 是您浏览网站和使用关键功能所必需的。它们支持基本功能，如在线商店的订单处理和访问网页的安全区域。它们还用于匿名分析用户模式，我们使用这些数据不断开发和改进我们的网页。",
    "categoryTextAnalytics": "这些 cookies 帮助我们更好地理解用户行为。分析 cookies 允许原始提供商或第三方提供商将使用和识别数据编译成匿名使用档案。我们使用分析 cookies 例如确定网页或服务的单个访问者数量，收集产品性能的统计数据，并基于匿名和伪匿名信息分析访问者的使用模式和交互。这些信息无法追溯到个人。",
    "categoryTextMarketing": "这些 cookies 和类似技术用于显示个性化的、因此相关的营销内容。营销 cookies 用于显示有趣的广告内容并衡量我们活动的有效性。这不仅在电信网站上进行，还在其他广告合作伙伴网站（第三方提供商）上进行。这被称为重新定位，用于创建伪匿名内容或广告档案，在其他网站上放置相关广告，并推导目标群体的见解，这些群体查看了广告和内容。这些信息无法追溯到个人。营销和重新定位工具帮助我们为您提供可能相关的广告内容。如果禁用营销 cookies，您看到的广告数量不会减少，但可能与您的相关性较低。",
    "categoryTextThirdParty": "电信的网站包括指向第三方服务提供商的链接，这些提供商在自己的责任下提供服务。当您访问电信的网页时，cookies 或类似技术会记录数据并将其发送给第三方，部分用于电信自身的目的。第三方自身目的的处理范围、目的和法律依据可在第三方的隐私信息中找到。有关独立第三方提供商的信息可在隐私信息中找到。"
  },
  "messages": {
    "noDataAvailable": "无可用数据",
    "noMatchFound": "未找到匹配项",
    "maximumFileSize": "最大文件大小",
    "suitableFileFormats": "适合的文件格式",
    "loading": "加载中...",
    "dragDropText": "或将文件拖放到此处",
    "noConnectors": "未找到连接器！",
    "comingSoon": "即将推出"
  },
  "pageNotFound": {
    "title": "哎呀！您寻找的页面尚不存在。",
    "subtitle": "与此同时，请查看我们的其他资源，可能会对您有所帮助！"
  },
  "helpResources": {
    "needHelp": "需要帮助选择合适的计划、获取更多信息或解答技术问题？",
    "needHelpShorter": "需要更多帮助吗？",
    "developerDoc": "API 文档",
    "developerDocDesc": "获取用于数据交换自动化的API文档",
    "example": "示例",
    "examples": "用户指南",
    "tutorials": "教程",
    "exampleDescription": "查找与您的行业相关的用例和演示",
    "FAQ": "常见问题",
    "FAQDescription": "查找从计费到隐私的更多常见答案",
    "browse": "浏览",
    "demos": "演示",
    "demosDescription": "查找与您的行业相关的用例和演示",
    "glossary": "术语表",
    "glossaryDescription": "查找与数据智能中心、IDSA、Catena-X、Gaia-X 等相关的术语和定义。",
    "glossaryDescriptionShorter": "查找 Catena-X、Gaia-X 等的术语和定义",
    "customerSupport": "客户支持",
    "customerSupportDesc": "没有找到您想要的内容？",
    "contactUs": "当前订阅不支持此功能。如需升级，请联系我们。",
    "contactUsBtn": "联系我们"
  },
  "basicInfo": {
    "title": "基本信息",
    "dataspace": "数据空间",
    "bpn": "业务伙伴编号"
  },
  "feedbackCard": {
    "title": "需要更多帮助？",
    "contactUs": "联系我们"
  },
  "error": {
    "pageNotFound": "页面未找到 (404)",
    "somethingWrong": "出了点问题！",
    "propertyNotFound": "属性未找到",
    "uniquePropertyName": "属性名称必须唯一",
    "dctTypeNotFound": "dct:type 未找到"
  },
  "helpWidget": {
    "askSupport": "询问支持",
    "chatboxTitle": "帮助聊天",
    "chatboxSubtitle": "电信数据智能中心支持",
    "defaultMessage": {
      "body": "您好，欢迎体验电信数据智能中心支持频道。请在下方选择一个选项。"
    },
    "whatCanWeHelpWith": "今天我们能帮您什么？",
    "suggestedAnswers": {
      "knowledgeBase": "知识库、文档和常见问题",
      "contactSupport": "联系支持",
      "contactSales": "联系销售"
    }
  },
  "pcfExchange": {
    "title": "PCF 交换",
    "description": "欢迎体验 Catena-X 中简单易用的端到端产品碳足迹（PCF）交换解决方案。",
    "recentRequests": "最近的 PCF 数据请求",
    "viewAllRequests": "查看所有请求",
    "requestPcf": "请求 PCF",
    "termCheck": "通过提交请求，我理解合同将根据数据提供者设定的政策进行协商。",
    "pcfSuccess": "PCF 请求成功！",
    "landing": {
      "pcfTitle": "创建 PCF 优惠",
      "pcfDesc": "在 Catena-X 网络中创建并与参与者分享 PCF 数据。",
      "discoverTitle": "发现和请求 PCF 数据",
      "discoverDesc": "在 Catena-X 网络中轻松搜索 PCF 数据或通过几个步骤从您的合作伙伴请求 PCF 数据。",
      "pcfReqTitle": "PCF 数据请求",
      "pcfReqDesc": "在 Catena-X 网络中高效管理来自您合作伙伴的 PCF 数据请求。",
      "pcfCalcTitle": "PCF 计算器",
      "pcfCalcDesc": "计算 PCF 值并无缝连接到您的应用程序或 PCF 数据交换场景。",
      "pcfHistoryTitle": "PCF 数据交换历史",
      "pcfHistoryDesc": "在 Catena-X 网络和您的合作伙伴中获得 PCF 数据交换历史的透明度。",
      "documentation": "了解 PCF 数据交换",
      "howTo": {
        "description": "在 Catena-X 中分享、发现和管理产品碳足迹（PCF）数据优惠。",
        "doc": "想了解更多关于连接和集成的信息？文档链接："
      }
    },
    "requests": {
      "pcfRequests": "PCF 数据请求",
      "reqDesc": "使用此区域管理来自合作伙伴的 PCF 数据请求。",
      "productId": "产品 ID*",
      "bpn": "业务PN*",
      "message": "消息",
      "howTo": {
        "title": "想了解更多关于 PCF 数据请求管理工作的信息？",
        "description": "使用此部分批准或拒绝来自您合作伙伴的 PCF 数据请求。此外，查看 PCF 数据交换的状态并在您的 PCF 数据链中获得完全透明度。",
        "doc": "想了解更多关于数据优惠协商和消费如何运作的信息？"
      }
    },
    "responses": {
      "howTo": {
        "description": "发现其他 Catena-X 成员公司的数据优惠目录。您可以搜索、选择和订阅数据优惠。您可以使用公司名称或制造商零件 ID 或两者的组合搜索数据优惠。"
      }
    },
    "view": {
      "title": "查看 PCF 详情"
    }
  },
  "pcfExchangeV9": {
    "landing": {
      "pcfReqTitle": "PCF Provider",
      "pcfHistoryTitle": "PCF Consumer"
    },
    "aspects": {
      "title": "PCF 方面",
      "description": "查看您已提供的所有 PCF 值和方面。",
      "cardDescription": "查看您已提供的所有 PCF 值和方面，即使在交换之前。",
      "responses": "响应",
      "assets": "资产"
    },
    "incomingRequests": "传入PCF请求",
    "sentResponses": "已发送PCF响应",
    "sentRequests": "已发送PCF请求",
    "incomingResponses": "传入PCF响应",
    "requests": {
      "pcfRequests": "PCF Provider",
      "partIdDescription": "请提供制造商部件 ID 或客户部件 ID。至少需要其中一个。",
      "manufacturerPartId": "制造商部件 ID",
      "customerPartId": "客户部件 ID",
      "eitherPartIdRequired": "需要提供制造商部件 ID 或客户部件 ID。"
    }
  },
  "cyberSecurityKPIs": {
    "title": "网络安全指标",
    "historyTitle": "发送了网络安全指标历史",
    "historySubTitle": "这里你可以看到共享的数据历史",
    "description": "欢迎来到与OEM用户共享的便捷网络安全数据共享平台",
    "nothinghere": "这里还没有消息！",
    "newEntryAppearance": "当你创建新条目时，它会出现在这里。",
    "createKPITitle": "创建并发送网络安全指标",
    "createKPISubTitle": "请务必一次性填写所有细节。如果你选择在发送前取消，数据将不会被保存。如果您选择取消，您将被重定向到用例仪表盘，并需从一开始填写详细信息。",
    "createKPIDocumentationDesclaimer": "有关如何填写表格及OEM的其他要求, 请遵循我们的{documentation}。",
    "documentation": "文档",
    "generalInformation": "一般信息",
    "measurementYear": "测量年份",
    "receiverBpn": "接收BPN",
    "confirmationText": "提交请求时，我理解合同将根据数据提供商制定的政策协商数据报价。",
    "successTitle": "成功",
    "successDescription": "你的数据已经成功共享。职位ID是 {id}",
    "sendMetricsFailed": "共享数据时出现错误。",
    "kpiKnowledgeBase": "了解更多关于使用场景的信息",
    "kpiFirstEntry": "开始吧，创建你的第一篇文章",
    "metricsInformation": {
      "title": "指标信息",
      "measurementDate": "测量日期",
      "value": "价值",
      "kpiNotSharedReason": "不分享度量的原因",
      "enclosedSiteTitle": "封闭遗址",
      "enclosedSiteLabel": "选择你所附的网站"
    },
    "modal": {
      "leaveTitle": "不保存就离开？",
      "leaveDescription": "如果您现在关闭此表单，您输入的数据将丢失。",
      "discardBtn": "删除更改",
      "continueEditingBtn": "继续编辑",
      "confirmTitle": "确认发送",
      "confirmDescription": "发送后，此消息无法编辑或召回。",
      "confirmReviewBtn": "重新审核"
    },
    "helpCard": {
      "title": "它是如何工作的？",
      "description": "与 BMW 分享年度网络安全 KPI 数据。在这里可以查看所有 ранее 记录信息的完整概览。",
      "subtitle": "想了解更多关于网络安全指标使用场景的信息吗？"
    },
    "metricsViewer": {
      "jobId": "作业ID",
      "threadId": "线程ID",
      "stepId": "步骤ID",
      "header": "头部",
      "messageId": "消息ID",
      "senderBpn": "发送方BPN",
      "receiverBpn": "接收BPN",
      "senderFeedbackUrl": "发送方反馈URL",
      "content": "内容",
      "reportId": "报告ID",
      "kpiShared": "共享KPI"
    }
  },
  "publicationTemplates": {
    "title": "我的发布模板",
    "deletedTemplates": "我的已删除模板",
    "showDeletedTemplates": "显示已删除模板",
    "hideDeletedTemplates": "显示活跃模板",
    "newTemplate": "新模板",
    "create": {
      "title": "创建发布模板",
      "edit": "编辑发布模板",
      "templateName": "模板名称",
      "templateType": "{type} 模板",
      "create": "创建",
      "update": "更新",
      "modifiedAt": "修改时间",
      "accessPolicyId": "访问政策",
      "usagePolicyId": "使用政策",
      "isEnabled": "是否启用",
      "targetCompany": "目标公司",
      "targetConnectors": "目标连接器",
      "selectCountry": "选择国家",
      "templateDetails": "发布模板详情",
      "assetsCriteria": "资产选择标准",
      "connectorDetails": "连接器详情"
    },
    "delete": {
      "title": "删除发布模板",
      "description": "您确定要删除此模板吗？",
      "button": "删除"
    }
  },
  "contracts": {
    "title": "合同协议详情",
    "provider": {
      "description": "这是您组织与其他数据空间参与者的合同协议概览。",
      "note": "请注意，以下列表显示的是所有用例的数据。我们将很快推出按用例预筛选的数据列表以及高级搜索和筛选功能。在此期间，请使用搜索和筛选选项从以下列表中查找相关数据。",
      "howItWorks": {
        "description": "在这里您可以找到跨各种数据空间的订阅或协商数据协议。您可以按特定连接器过滤结果，或使用合同协议 ID 或资产 ID 进行搜索。您还可以根据需求对列表进行排序。此外，您可以选择数据优惠并在本地导出。",
        "subtitle": "想了解更多关于数据优惠协商和消费如何运作的信息？"
      },
      "details": {
        "title": "提供的合同协议详情",
        "description": "描述",
        "content": "内容",
        "agreementDetails": "协议详情",
        "assetDetails": "资产详情",
        "usagePolicy": "使用政策"
      }
    },
    "consumer": {
      "description": "这是您组织对其他数据空间参与者数据优惠的合同协议概览。",
      "downloadData": "下载数据",
      "downloadAgreement": "下载协议",
      "reinitiate": "启动传输和下载数据",
      "error": {
        "heading": "抱歉！您似乎已经协商过此合同。",
        "body": "您无法重新协商已协商的合同。您可以在下方找到合同详情，还可以下载此协议并订阅数据。"
      },
      "details": {
        "title": "消费的合同协议详情"
      },
      "howItWorks": {
        "description": "在这里您可以找到跨各种数据空间的订阅或协商数据协议。您可以按特定连接器过滤结果，或使用合同协议 ID 或资产 ID 进行搜索。您还可以根据需求对列表进行排序。此外，您可以选择数据优惠并在本地导出。",
        "subtitle": "想了解更多关于数据优惠协商和消费如何运作的信息？"
      }
    }
  },
  "provider": {
    "provider": "提供者",
    "assets": {
      "title": "我的资产",
      "offeredBy": "提供者：",
      "offers": "优惠",
      "created": "创建时间",
      "modifiedAt": "修改时间",
      "noResultsFound": "未找到资产",
      "success": "资产创建成功",
      "updateSuccess": "资产更新成功",
      "buttons": {
        "createOffer": "创建优惠",
        "details": "查看详情",
        "delete": "删除资产",
        "create": "创建资产",
        "edit": "编辑资产",
        "update": "更新资产",
        "showDeleted": "显示已删除资产",
        "hideDeleted": "隐藏已删除资产",
        "restore": "恢复资产",
        "add": "添加键值对",
        "addJson": "添加 JSON 对象",
        "editJson": "编辑 JSON 对象",
        "saveJson": "保存 JSON",
        "advanceAddition": "高级添加",
        "unpublish": "不公开资产",
        "showAssets": "显示资产"
      },
      "detailsDialog": {
        "title": "资产详情"
      },
      "createDialog": {
        "title": {
          "general": "创建新资产",
          "edit": "编辑资产",
          "addProperties": "添加属性",
          "advance": "高级属性添加"
        },
        "publicProps": "公共属性",
        "privateProps": "私有属性",
        "dataAddress": "数据地址",
        "dataSources": "数据源",
        "dataDestination": "数据目的地",
        "json": {
          "fields": "JSON 字段",
          "editor": "自定义属性编辑器",
          "formatted": "自定义属性查看器",
          "error": "无效 JSON：",
          "placeholder": "输入自定义属性 JSON"
        },
        "connectionTypeLabel": {
          "http": "请输入 URL",
          "s3": "请输入对象名称",
          "azure": "请输入 Blob 名称",
          "sftp": "请输入文件名"
        },
        "fields": {
          "name": "名称",
          "namePlaceholder": "输入优惠名称",
          "description": "描述",
          "version": "版本",
          "contentType": "内容类型",
          "contentTypePlaceholder": "输入内容类型",
          "keywords": "关键字",
          "language": "语言",
          "languagePlaceholder": "选择语言",
          "semanticId": "语义 ID",
          "semanticIdPlaceholder": "请输入语义 ID",
          "dct:type": "DCT：类型",
          "dct:typePlaceholder": "选择 dct 类型",
          "keywordsPlaceholder": "添加关键字",
          "descriptionPlaceholder": "编写优惠描述",
          "versionPlaceholder": "版本号",
          "dataType": "数据地址类型",
          "dataTypePlaceholder": "选择数据地址类型",
          "dataAddressUrl": "资产 URL",
          "dataAddressUrlPlaceholder": "输入资产 URL",
          "targetCompany": "目标公司",
          "targetCompanyPlaceholder": "输入目标公司",
          "country": "国家",
          "countryPlaceholder": "输入国家",
          "key": "键",
          "keyPlaceholder": "输入键",
          "value": "值",
          "valuePlaceholder": "输入值",
          "assetType": "资产类型",
          "assetTypePlaceholder": "输入资产类型"
        },
        "validation": {
          "name": "请输入名称",
          "assetType": "请选择资产类型",
          "contentType": "请输入有效的内容类型",
          "dataType": "请选择有效的数据类型",
          "targetCompany": "请输入有效的目标公司",
          "country": "请输入有效的国家"
        }
      },
      "tags": {
        "restricted": "访问受限",
        "unrestricted": "无限制"
      },
      "search": {
        "title": "搜索过滤器",
        "helperText": "搜索资产名称、创建日期或类型",
        "filters": {
          "byName": "资产名称",
          "byType": "资产类型",
          "byDate": "修改日期",
          "byAssetId": "资产 ID"
        }
      },
      "delete": {
        "title": "删除资产",
        "description": "您确定要删除此资产吗？"
      },
      "unpublish": {
        "title": "不公开资产",
        "description": "您确定要未出版这项资产吗？"
      }
    },
    "fileUploadTerms": "我理解并确认我已正确填写所有必需的信息，如果信息不正确并拒绝报价，T-Systems 概不负责。",
    "fileUploadInfo": "T-Systems 不会检查此处填写的元数据信息的有效性。请确保您填写的信息正确完整。",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "单程输入",
    "bulkEntries": "批量条目"
  },
  "home": {
    "title": "连接与集成",
    "welcomeBack": "欢迎回来"
  },
  "gettingStarted": {
    "title": "需要帮助开始吗？",
    "openWizard": "打开向导",
    "yourDataOffering": "您的数据优惠",
    "yourAssets": "资产",
    "yourPolicies": "我的政策",
    "preconfiguredCatalogue": "预配置目录",
    "contractAgreements": "合同协议",
    "incomingAgreements": "传入协议",
    "outgoingAgreements": "传出协议",
    "connectors": "您的连接器",
    "providedAgreements": "提供的合同协议",
    "consumedAgreements": "消费的合同协议",
    "totalContracts": "合同总数"
  },
  "yourConnection": {
    "title": "您的连接器",
    "viewAllConnection": "查看所有连接器",
    "help": "帮助",
    "documentation": "了解您的连接与集成",
    "gettingStarted": "入门指南",
    "noUseCases": "没有可用用例",
    "activeUseCases": "已激活的用例",
    "useCasesAvailableToActivate": "可激活的用例",
    "open": "打开",
    "show": "显示",
    "pcfVersionModal": {
      "title": "PCF 交换版本",
      "description": "Connect & Integrate 支持以下 PCF 版本和规则手册部署，用于 Catena-X 网络内的 PCF 交换。请选择您首选的选项。请注意两个版本未连接。",
      "current": "当前",
      "deprecated": "已废弃",
      "rulebook": "规则手册",
      "pcfSubmodel": "PCF 子模型",
      "supportStatus": "支持状态",
      "statusActive": "活跃",
      "statusEol": "生命周期结束",
      "saturn": {
        "name": "Saturn",
        "description": "最新版本，具有增强功能和对当前可持续性标准的全面支持。推荐用于所有部署。"
      },
      "jupiter": {
        "name": "Jupiter",
        "description": "为向后兼容性而维护的遗留版本。强烈建议在支持期结束前迁移到 Saturn。"
      }
    }
  },
  "wizardSelectionPopup": {
    "whatToLike": "您今天想做什么？",
    "prepare": "准备",
    "govern": "治理",
    "provide": "提供",
    "consume": "消费",
    "howToProvide": "您今天想如何提供数据？",
    "manual": "手动",
    "automated": "通过 API 自动化",
    "selectUseCases": "选择您的用例",
    "selectSingleUseCase": "选择您的用例",
    "selectDigitalTwin": "选择您的数字孪生类型",
    "back": "返回",
    "publish": "我理解数据空间的框架要求，并同意代表我的组织在数据空间中发布数据优惠。"
  },
  "createOffer": {
    "title": {
      "standard": "创建数据优惠",
      "pcf": "创建 PCF 数据优惠",
      "certificate": "创建证书选件",
      "traceability": "创建可追溯性数据报价"
    },
    "publish": "发布",
    "legalConfirmation": "我理解数据空间的框架要求，并同意代表我的组织在数据空间中发布数据优惠。",
    "wizard": {
      "provisionAsset": "提供资产",
      "dataUpload": "数据选择",
      "attachPolicy": "附加政策",
      "publishDataOffer": "发布数据优惠"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "您想为哪个子模型创建数据优惠？",
      "selectSubmodel": "选择子模型",
      "selectUsecase": "选择用例",
      "selectDigitalTwinType": "选择数字孪生类型",
      "whichTypeToSelect": "我应该选择哪种类型？",
      "generalInformation": "常规信息",
      "description": "描述",
      "contentType": "内容类型",
      "keywords": "关键字",
      "language": "语言",
      "location": {
        "title": "位置和寻址",
        "text": "请输入您的资产详情"
      },
      "username": "用户名",
      "password": "密码",
      "assetUrl": "资产 URL",
      "assetUrlPlaceHolder": "请输入您的资产 URL",
      "clientId": "客户端 ID",
      "clientSecret": "客户端密钥",
      "tokenUrl": "令牌 URL",
      "tokenUrlPlaceHolder": "请输入您的令牌 URL",
      "provideAssets": "提供资产",
      "selectConnectorLabel": "选择您想与之共享数据的连接器",
      "selectConnectorPlaceholder": "选择连接器",
      "selectRestApiType": "选择 REST-API 类型",
      "selectedAuthMethod": "认证方法"
    },
    "dataUpload": {
      "selectUploadType": "选择您的上传类型",
      "selectedDataModel": "选择您的数据",
      "csvUpload": {
        "title": "CSV 文件",
        "description": "将文件拖放到此处",
        "uploadFile": "选择文件",
        "uploadFileDescription": "准备并上传您想要交换的文件。您可以下载示例文件以帮助您开始使用 Catena-X 所需的格式。",
        "uploadFileDescriptionNote1": "从下面的链接下载模板文件",
        "uploadFileDescriptionNote2": "在提供的文件中填写您的合作伙伴详情",
        "uploadFileDescriptionNote3": "在提供的区域上传文件",
        "partnerValidationNote": "如果您想了解更多关于合作伙伴验证的信息，请",
        "clickHere": "点击这里",
        "downloadTemplate": "下载模板",
        "downloadSampleCsv": "下载示例 CSV",
        "supportedFileTypes": "支持的文件类型："
      },
      "jsonUpload": {
        "title": "JSON",
        "submodelJson": "子模型JSON",
        "downloadTemplate": "下载模板",
        "downloadSampleJson": "下载示例 JSON",
        "uploadFileDescription": "准备并上传您想要交换的文件。",
        "invalidJson": "提供的内容不是有效的JSON。请检查输入后重试。",
        "schemaValidationFailed": "Catena-X 模式验证失败",
        "issue": "个问题",
        "issues": "个问题"
      },
      "operationMode": {
        "title": "选择操作模式",
        "description": "现在决定如何获取此孪生的外壳。",
        "createNew": {
          "title": "创建新的数字孪生",
          "description": "在 CX-Core 中注册新的 AAS 外壳"
        },
        "useExisting": {
          "title": "使用现有数字孪生",
          "description": "链接到 CX-Core 中已有的外壳"
        }
      },
      "useExisting": {
        "searchTitle": "在 CX-Core 中搜索现有外壳",
        "catenaXId": "Catena-X ID",
        "search": "搜索",
        "reset": "重置",
        "noResults": "未找到匹配的数字孪生。",
        "searchError": "搜索数字孪生失败。请重试。",
        "matchingTypeNote": "仅列出与所选数字孪生类型匹配的外壳。",
        "propertiesTitle": "数字孪生属性",
        "readOnly": "（只读）"
      },
      "digitalTwinProperties": {
        "title": "数字孪生属性",
        "specificAssetIds": "特定资产ID"
      },
      "tableUpload": {
        "title": "表格",
        "description": "提供自定义表格条目",
        "add": "添加"
      },
      "fileUpload": {
        "title": "文件上传",
        "description": "CSV、JSON"
      },
      "objectStorage": {
        "title": "对象存储",
        "description": "AWS、Azure、OTC 或 GCP"
      },
      "sftp": {
        "title": "SFTP 服务器",
        "description": "通过 SFTP 传输"
      },
      "apiUpload": {
        "title": "休息API",
        "description": "通过 API 传输",
        "authAndIdentiTitle": "认证和身份验证",
        "authAndIdentiDesc": "请输入您目标系统的认证详情",
        "selectApiType": "选择 REST-API 类型",
        "locationAndAddrTitle": "位置和寻址",
        "locationAndAddrDesc": "请输入您的资产详情",
        "assetUrl": "资产 URL",
        "username": "用户名",
        "password": "密码",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥"
      }
    },
    "fileUpload": {
      "title": "将您的文件拖放到此处",
      "btnText": "选择文件"
    },
    "attachPolicy": {
      "title": "为此数据优惠附加政策",
      "createPolicy": "创建新政策",
      "bpnFieldTitle": "您想与谁交换数据？",
      "howItWork": {
        "title": "它是如何工作的？",
        "description": "我们根据 Catena-X 用例框架协议预配置政策。仅允许提供的业务合作伙伴编号访问您的数据。",
        "knowMore": "想了解更多关于政策的信息？",
        "documentation": "文档"
      },
      "accessPolicyTableText": "为此数据优惠附加访问政策",
      "usagePolicyTableText": "为此数据优惠附加使用政策",
      "heading": {
        "title": "附加现有政策或创建新政策",
        "description": "请从下表附加访问和使用政策以完成数据优惠发布。您还可以使用政策名称搜索政策，或者在没有所需政策时创建新政策。"
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "数据优惠详情",
      "generalInformation": "常规信息",
      "attribute": "属性",
      "value": "值",
      "knowMore": "了解更多关于您的数据优惠",
      "attachedDataAssets": "附加项目",
      "attachedPolicies": "附加政策",
      "allowPolicyPublish": "我允许政策发布",
      "publish": "发布",
      "verifiedLegalEntity": "由以下验证的法人实体",
      "dataOfferCreatedBy": "数据优惠创建者：",
      "contactOrgAdmin": "联系组织管理员",
      "help": "帮助",
      "attachedDataAsset": "附加数据资产",
      "attachedAccessPolicy": "附加访问政策",
      "attachedUsagePolicy": "附加使用政策",
      "publishedConnectors": "此优惠将发布到的连接器",
      "knowMoreConnector": "了解更多关于您的连接器",
      "knowMorePolicies": "了解更多关于您的政策",
      "knowMoreDataAssets": "了解更多关于您的数据资产",
      "knowMoreDataOffers": "了解更多关于您的数据优惠",
      "publishCheckboxLabel": "我代表我的组织同意在数据空间中发布数据优惠和资产。我确认使用相关政策来管理数据空间及其相关政策，并且我将遵循数据空间的框架对已发布的优惠和资产进行任何操作。"
    },
    "result": {
      "success": {
        "title": "请求成功。",
        "description": "资产发布流程已开始！任务 ID 为 {id}"
      }
    },
    "success": {
      "title": "您的数据优惠现已发布",
      "description": "您的数据优惠现已发布，点击以下内容查看后续步骤",
      "createOffer": "创建另一个数据优惠",
      "createOfferButton": "创建",
      "goToHome": "返回首页",
      "goToHomeButton": "返回首页",
      "uploadHistory": "检查您的上传历史"
    }
  },
  "policy": {
    "newPolicy": "新政策",
    "showDeletedPolicies": "显示已删除政策",
    "myDeletedPolicies": "我的已删除政策",
    "hideDeletedPolicies": "显示活跃政策",
    "restoreAsset": "恢复",
    "publishDeletion": "发布删除",
    "create": {
      "title": "创建新政策",
      "edit": "编辑政策",
      "policyName": "政策名称",
      "policyType": "{type} 政策",
      "accessPolicy": "访问政策",
      "usagePolicy": "使用政策",
      "create": "创建并保存",
      "update": "更新"
    },
    "delete": {
      "title": "删除政策",
      "description": "您确定要删除此政策吗？",
      "button": "删除"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "业务合作伙伴编号",
        "description": "业务合作伙伴数量限制可用于定义允许哪些具体业务合作伙伴（基于 BPNL）查看或协商相应的数据报价。"
      },
      "BusinessPartnerGroup": {
        "title": "业务合作伙伴组",
        "description": "业务合作伙伴组限制可用于定义允许哪些具体业务合作伙伴（基于 BPNL）查看或协商相应的数据报价。"
      },
      "Membership": {
        "title": "会员资格",
        "description": "会员凭证可用于确保只有 CX 会员才能查看或协商相应的数据优惠。"
      },
      "ContractReference": {
        "title": "合同参考",
        "description": "合同参考限制可用于定义在哪些双边合同详细信息下共享数据。"
      },
      "Dismantler": {
        "title": "拆解员",
        "description": "持有该资质的企业为拆解企业。",
        "allowedBrands": {
          "title": "拆解员允许的品牌",
          "description": "定义拆解员的公司角色。持有该资质的企业为拆解企业。"
        }
      },
      "UsagePurpose": {
        "title": "使用目的",
        "description": "使用目的"
      },
      "FrameworkAgreement": {
        "title": "框架协议",
        "description": "有了框架协议凭证，只有那些签署了相应框架协议（通用或特定版本）的参与者才被允许查看或协商相应的数据要约。"
      },
      "Duration": {
        "title": "期间",
        "description": "从签署之日起的数据使用期限。"
      },
      "inForceDate": {
        "title": "固定日期范围",
        "description": "数据使用的固定日期时间范围。"
      },
      "connector": {
        "title": "连接器限制",
        "description": "持有连接器的公司因该限制而使用。"
      },
      "AffiliatesBpnl": {
        "title": "关联公司",
        "description": "记录（不检查）关联业务合作伙伴。"
      },
      "AffiliatesRegion": {
        "title": "关联公司地区",
        "description": "记录（不检查）关联公司所在地区。"
      },
      "ConfidentialInformationMeasures": {
        "title": "机密信息措施",
        "description": "记录（不检查）是否必须采取机密措施。"
      },
      "ConfidentialInformationSharing": {
        "title": "机密信息共享",
        "description": "记录（不检查）是否必须采取机密措施。"
      },
      "ContractTermination": {
        "title": "合同终止",
        "description": "记录（不检查）合同终止后消费者应如何处理数据。"
      },
      "DataFrequency": {
        "title": "数据频率",
        "description": "记录（不检查）资产传输频率。"
      },
      "DataProvisioningEndDate": {
        "title": "数据供应结束",
        "description": "记录（不检查）资产供应结束的绝对日期。"
      },
      "DataProvisioningEndDurationDays": {
        "title": "数据供应天数",
        "description": "记录（不检查）资产供应持续时间。"
      },
      "DataUsageEndDate": {
        "title": "数据使用结束",
        "description": "记录（不检查）资产消费结束的绝对日期。"
      },
      "DataUsageEndDurationDays": {
        "title": "数据使用天数",
        "description": "记录（不检查）资产消费持续时间。"
      },
      "DataUsageEndDefinition": {
        "title": "数据使用结束定义",
        "description": "记录（不检查）资产消费持续时间。"
      },
      "JurisdictionLocation": {
        "title": "管辖地",
        "description": "以纯文本形式记录（不检查）本合同的管辖范围"
      },
      "JurisdictionLocationReference": {
        "title": "管辖地参考",
        "description": "记录（不检查）本合同相对于相关方的管辖范围"
      },
      "Liability": {
        "title": "责任",
        "description": "记录（不检查）本合同对相关方的责任"
      },
      "ManagedLegalEntityBpnl": {
        "title": "受管法律实体",
        "description": "记录（不检查）提供方为其管理资产的业务合作伙伴。"
      },
      "ManagedLegalEntityRegion": {
        "title": "受管法律实体地区",
        "description": "记录（不检查）提供方为其管理资产的地区。"
      },
      "Precedence": {
        "title": "优先级",
        "description": "记录（不检查）哪个合同框架优先"
      },
      "ExclusiveUsage": {
        "title": "独占使用",
        "description": "记录（不检查）该资产专门提供给消费者"
      },
      "UsageRestriction": {
        "title": "使用限制",
        "description": "记录（不检查）消费者不能对该资产做什么"
      },
      "VersionChanges": {
        "title": "版本变更",
        "description": "记录（不检查）资产可能发生的版本变更类型"
      },
      "Warranty": {
        "title": "保修",
        "description": "记录（不检查）消费者对资产获得的保修"
      },
      "WarrantyDefinition": {
        "title": "保修定义",
        "description": "记录（不检查）消费者对资产获得的保修期"
      },
      "WarrantyDurationMonths": {
        "title": "保修期限",
        "description": "记录（不检查）消费者对资产获得的保修期（月）。"
      }
    },
    "fields": {
      "BusinessPartnerNumber": "业务合作伙伴编号",
      "tx:BusinessPartnerGroup": "业务合作伙伴组",
      "cx-policy:Membership": "会员资格",
      "cx-policy:ContractReference": "合同参考",
      "cx-policy:Dismantler.allowedBrands": "拆解员允许的品牌",
      "cx-policy:Dismantler": "拆解员",
      "cx-policy:UsagePurpose": "使用目的",
      "cx-policy:FrameworkAgreement": "框架协议",
      "duration": "期间",
      "unit": "单元",
      "fromdate": "开始日期",
      "todate": "迄今为止",
      "connector": "连接器",
      "cx-policy:AffiliatesBpnl": "关联公司",
      "cx-policy:AffiliatesRegion": "关联公司地区",
      "cx-policy:ConfidentialInformationMeasures": "机密信息措施",
      "cx-policy:ConfidentialInformationSharing": "机密信息共享",
      "cx-policy:ContractTermination": "合同终止",
      "cx-policy:DataFrequency": "数据频率",
      "cx-policy:DataProvisioningEndDate": "数据供应结束",
      "cx-policy:DataProvisioningEndDurationDays": "数据供应天数",
      "cx-policy:DataUsageEndDate": "数据使用结束",
      "cx-policy:DataUsageEndDurationDays": "数据使用天数",
      "cx-policy:DataUsageEndDefinition": "数据使用结束定义",
      "cx-policy:JurisdictionLocation": "管辖地",
      "cx-policy:JurisdictionLocationReference": "管辖地参考",
      "cx-policy:Liability": "责任",
      "cx-policy:ManagedLegalEntityBpnl": "受管法律实体",
      "cx-policy:ManagedLegalEntityRegion": "受管法律实体地区",
      "cx-policy:Precedence": "优先级",
      "cx-policy:ExclusiveUsage": "独占使用",
      "cx-policy:UsageRestriction": "使用限制",
      "cx-policy:VersionChanges": "版本变更",
      "cx-policy:Warranty": "保修",
      "cx-policy:WarrantyDefinition": "保修定义",
      "cx-policy:WarrantyDurationMonths": "保修期限"
    }
  },
  "jobs": {
    "jobs": "任务",
    "name": "名称",
    "startedAt": "开始时间",
    "duration": "持续时间",
    "jobDetails": "处理详情",
    "reload": "重新加载",
    "noDetailsAvailable": "此任务没有更多详情",
    "retry": "重试"
  },
  "search-offer": {
    "pageTitle": "搜索数据优惠",
    "pcfTitle": "搜索 PCF 数据优惠",
    "pcfV9Title": "搜索 PCF v9 数据优惠",
    "certificateTitle": "搜索业务合作伙伴证书报价",
    "filter": {
      "bpnSearch": "通过您的业务合作伙伴编号或公司名称搜索",
      "bpnSearchNote": "通过公司名称或 BPN 查找数据优惠。",
      "manufacturePartId": "制造商零件 ID",
      "manufacturePartIdNote": "搜索与给定零件 ID 匹配的所有数据优惠。",
      "enter": "输入 {field}",
      "connectorUrl": "连接器 URL",
      "connectorUrlNote": "在特定连接器中搜索数据",
      "subModel": "子模型",
      "subModelNote": "为您的预期用例优化搜索结果",
      "search": "搜索",
      "searchBy": "搜索方式",
      "resetFilters": "重置过滤器",
      "advancedSearch": "高级搜索",
      "dct:type": "DCT：类型",
      "assetId": "资产 ID"
    },
    "noResult": {
      "title": "无结果",
      "description": "请搜索以浏览网络中可用的数据优惠"
    },
    "helpCard": {
      "title": "它是如何工作的？",
      "description": "发现其他数据空间参与者的数据优惠目录。您可以搜索、选择和订阅数据空间中可用的数据优惠。",
      "subtitle": "想了解更多关于数据优惠协商和消费如何运作的信息？",
      "documentation": "文档"
    },
    "offers": {
      "downloadSelected": "下载所选",
      "transferSelected": "传输所选",
      "negotiate": "协商",
      "noOffer": "没有可用的数据优惠。"
    },
    "offer-details": {
      "title": "确认合同协商",
      "description": "描述",
      "attachedPolicies": "附加政策",
      "termsCheck": "我同意合同条款，并希望开始合同协商和数据交换。",
      "negotiate": "协商",
      "negotiateAndDownload": "协商并下载",
      "negotiateAndTransfer": "协商并传输",
      "transfer": "传输",
      "cancel": "取消",
      "attribute": "属性",
      "value": "值",
      "endpointUrl": "端点 URL",
      "organization": "组织",
      "bpnNumber": "BPN 编号",
      "manufacturerPartId": "制造商零件 ID",
      "noOfAssets": "所选资产数量",
      "membership": "成员资格",
      "dismantlerBrands": "允许的拆解品牌",
      "frameworkAgreement": "框架协议",
      "dismantler": "拆解者",
      "backToAssets": "返回资产",
      "noPolicyMatchTitle": "资产未协商或政策不一致",
      "noPolicyMatchText": "您尝试下载的某些资产尚未协商。或者，您尝试协商的某些资产的政策不一致。请选择正确的资产并继续。",
      "negotiateInProgress": "协商和下载正在进行",
      "negotiateAndDownloadSuccess": "协商和下载成功完成",
      "negotiateAndTransferSuccess": "协商和传输成功完成",
      "transferSuccess": "传输成功完成",
      "progress": "进度",
      "fetchShell": "获取外壳",
      "exportToCSV": "导出到 CSV",
      "fetchJobFailed": "获取任务详情时出错",
      "negotiateError": "下载资产时出错",
      "dtr": "数字孪生注册表",
      "edc": "连接器资产",
      "browseDtr": "浏览 DTR"
    },
    "existingContracts": {
      "heading": "可用合同",
      "description": "这里将有一个非凡的描述！"
    },
    "dtr": {
      "title": "数字孪生外壳",
      "shells": "浏览外壳",
      "description": "您将自动协商从所选提供者的数字孪生注册表中获取和导出外壳",
      "noPoliciesFound": "没有找到该资产的政策",
      "errorFetchingPolicies": "获取策略时出错。",
      "negotiate": "谈判"
    },
    "traceabilityTitle": "发现可追溯性数据"
  },
  "catalogSimulation": {
    "pageTitle": "模拟数据优惠",
    "note": "检查您现有的哪些数据优惠会对特定数据空间参与者可见。模拟另一个数据空间参与者,并选择您假设其钱包中可用的凭证。该模拟会验证您配置的访问和使用政策是否授予对目标优惠的访问权限。使用此功能可验证您的数据优惠,并识别可能阻止其他参与者访问这些优惠的政策配置问题。",
    "protocol": "Dataspace Protocol",
    "protocolSaturn": "DSP Saturn",
    "protocolJupiter": "DSP Jupiter",
    "bpnSearch": "按业务合作伙伴编号或公司名称搜索",
    "credentials": "凭证",
    "credentialsNote": "选择模拟参与者可用的凭证。",
    "simulate": "模拟",
    "policy": "政策",
    "credential": {
      "bpn": "业务合作伙伴编号",
      "membership": "会员资格",
      "dataExchangeGovernance": "数据交换治理",
      "sampleDismantler": "示例拆解员"
    },
    "viewPolicy": "查看政策"
  },
  "assetUploadHistory": {
    "title": "资产上传历史",
    "subtitle": "此历史记录概述了您公司在数据空间连接器上的交易。所有关于资产、政策和合同定义的活动都列在此处。",
    "refresh": "刷新",
    "processId": "进程 ID",
    "providerUrl": "提供者 URL",
    "createdOn": "创建时间",
    "totalItems": "总项目",
    "successful": "成功",
    "failed": "失败",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "howItWork": {
      "title": "它是如何工作的？",
      "description": "您可以找到跨不同数据空间的所有上传资产历史记录。您可以在本地重新下载文件或将它们传输到外部位置。如有错误，您必须重试下载或重新协商数据优惠。",
      "moreInfo": "想了解更多关于上传历史及您可以在这里做什么？"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "历史记录为您提供了组织从数据空间协商合同中下载的数据概览。如有需要，您可以从此历史列表中再次下载数据。",
    "howItWorks": {
      "description": "您可以找到跨不同数据空间的所有下载资产历史记录。您可以在本地重新下载文件或将它们传输到外部位置。如有错误，您必须重试下载或重新协商数据优惠。",
      "moreInfo": "想了解更多关于下载历史及您可以在这里做什么？"
    },
    "downloadError": "下载不成功，请重试！",
    "viewErrors": "查看错误",
    "processId": "流程ID"
  },
  "digitalTwinBrowser": {
    "subHeading": "这些是您的数字孪生及其子模型。您的数字孪生通过您的数字孪生注册表暴露给数据空间。",
    "noDocumentError": "当前 ID 没有 aspectDocument",
    "nameNotProvided": "未提供名称",
    "fetchDigitalTwinsError": "无法获取数字孪生",
    "fetchAspectDocumentError": "无法获取方面文档",
    "fetchAspectModelError": "无法获取方面模型",
    "detailsOverviewModalTitle": "方面详情",
    "addItem": "添加项目",
    "detailsTable": {
      "idShort": "短 ID",
      "displayName": "显示名称",
      "modelUrn": "模型 URN"
    },
    "shellsTable": {
      "manufacturer": "制造商零件 ID",
      "modifiedBy": "用户",
      "modifiedAt": "时间"
    }
  },
  "connector": {
    "addNewConnector": "+ 添加新连接器",
    "searchConnector": "按连接器名称搜索",
    "connectorModal": {
      "error": "获取连接器详细信息失败"
    }
  },
  "column": {
    "name": "名称",
    "connectorName": "连接器名称",
    "contractId": "合同 ID",
    "productId": "产品 ID",
    "manufacturerPartId": "制造商零件 ID",
    "manufacturerId": "制造商 ID",
    "digitalTwinType": "数字孪生类型",
    "correlationId": "关联 ID",
    "requestId": "请求 ID",
    "bpn": "巴布亚新几内亚",
    "createdAt": "创建时间",
    "createdBy": "创建者",
    "attribute": "属性",
    "value": "值",
    "url": "网址",
    "actions": "操作",
    "lastUpdatedTime": "最后更新时间",
    "status": "状态",
    "requestedDate": "请求日期",
    "policyType": "政策类型",
    "modifiedBy": "修改者",
    "modifiedOn": "修改时间",
    "syncStatus": "同步状态",
    "assetId": "资产 ID",
    "assetType": "资产类型",
    "type": "类型",
    "createdFrom": "创建起始时间",
    "createdTo": "创建结束时间",
    "statusDuration": "状态/持续时间",
    "certifier": "验证者",
    "version": "版本",
    "registrationNumber": "注册号",
    "validUntil": "有效期截止",
    "offerId": "产品/服务 ID",
    "errorMessage": "错误信息",
    "globalAssetId": "全局资产ID",
    "shellName": "Shell名称",
    "contractAgreementId": "合同协议 ID",
    "signingDate": "签署日期",
    "providerConnectorUrl": "提供商连接器URL",
    "consumerConnectorUrl": "消费者连接器URL",
    "providerBpnl": "提供商BPNL",
    "consumerBpnl": "消费者BPNL",
    "counterPartyId": "对方 ID",
    "resourceId": "资源 ID",
    "resourceType": "资源类型",
    "transactionMethod": "交易方法",
    "trustLevel": "信任级别",
    "partId": "零件编号",
    "sentBy": "发送者",
    "partner": "合作伙伴",
    "sentOn": "发送时间",
    "intrinsicId": "固有的ID",
    "id": "ID",
    "catenaXId": "Catena-X ID",
    "customerPartId": "客户零件编号"
  },
  "messagesBrowser": {
    "fetchMessagesError": "无法获取消息",
    "openRelatedMessage": "打开相关消息",
    "messagesTable": {
      "context": "上下文",
      "senderBpn": "发送者 BPN",
      "receiverBpn": "接收者 BPN",
      "correlationId": "关联 ID",
      "jobId": "任务 ID",
      "conversationId": "对话 ID"
    },
    "messageType": {
      "ecu": "电子控制单元",
      "generic": "通用",
      "quality": "质量",
      "ccmpush": "CCM 推送",
      "ccmrequest": "CCM 请求",
      "ccmstatus": "CCM 状态",
      "ccmavailable": "CCM 可用",
      "blockNotification": "阻止通知",
      "dtrEvent": "DTR事件",
      "alert": "警报",
      "investigation": "调查",
      "csm": "CSM"
    }
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "基本证书信息",
        "issuer": "发行人信息",
        "validity": "有效期",
        "trust": "信任信息",
        "validator": "验证器信息",
        "application": "应用区",
        "enclosedSites": "封闭地点"
      },
      "fields": {
        "businessPartnerNumber": "业务伙伴编号",
        "registrationNumber": "注册号",
        "certificateType": "证书类型",
        "certificateVersion": "证书版本",
        "issuerName": "发行人名称",
        "issuerBpn": "发行人BPN",
        "validFrom": "有效",
        "validUntil": "有效直到为止",
        "trustLevel": "信任水平",
        "uploaderBpn": "上传器BPN",
        "validatorBpn": "验证器BPN",
        "validatorName": "验证器名称",
        "areaOfApplication": "申请区域",
        "siteBpn": "网站BPN",
        "siteAreaOfApplication": "申请现场区域"
      },
      "tooltips": {
        "basicInfo": "业务伙伴证书描述了证书（例如ISO9001，IATF-16949）",
        "businessPartnerNumber": "认证法律实体的业务伙伴编号（BPN）（签发证书）。",
        "registrationNumber": "证书中定义的证书的注册号",
        "certificateType": "文档中定义的证书类型，有效类型已在BPN元数据托管中注册",
        "certificateVersion": "文档中定义的证书的版本通常是认证标准的特定版本",
        "issuerName": "发行人的名称，即认证机构。",
        "issuerBpn": "发行人的业务伙伴编号（BPN）。",
        "validFrom": "从证书上定义的日期为有效。",
        "validUntil": "有效，直到证书上的定义为止。",
        "trustLevel": "给定证书的信任水平 - 无，低，高，值得信赖",
        "uploaderBpn": "业务伙伴的业务伙伴编号（BPN）最初提供了证明数据或文件。",
        "validatorBpn": "验证给定证书的数据服务提供商的业务伙伴号（BPN）",
        "validatorName": "验证给定证书的数据服务提供商的可选名称",
        "areaOfApplication": "详细信息，有关公司和 /或网站有效的哪些领域 /应用程序类型。",
        "siteBpn": "封闭网站的业务伙伴编号（BPN或BPNA）",
        "siteAreaOfApplication": "详细信息，有关公司和 /或网站有效的哪些领域 /应用程序类型。"
      }
    }
  },
  "bpnSelector": {
    "selectFromList": "从列表中选择",
    "enterManually": "手动输入",
    "selectPlaceholder": "选择位置 BPN",
    "manualPlaceholder": "输入 BPN（例如 BPNL123456789ABC）",
    "validFormat": "有效的 BPN 格式",
    "invalidFormat": "BPN 格式无效",
    "invalidFormatHint": "格式：BPNL + 12 个字母数字字符",
    "formatHint": "格式：BPNL123456789ABC（共16个字符）",
    "selected": "已选择"
  },
  "searchableSelect": {
    "pressEnterToUse": "按 Enter 键以使用此 BPNA/BPNS",
    "placeholderText": "请输入有效的 BPNA/BPNS",
    "placeholder": "选择或输入 BPNA/BPNS",
    "validBpnWarning": "警告！输入的 BPNA/BPNS 值未经任何来源验证，与 BP Explore 不同。如果您仍要使用它，请按 Enter 键。",
    "enterValidBpn": "输入有效的 BPNA/BPNS（预期格式 ^(BPNA|BPNS).{12}$）"
  },
  "blockNotifications": {
    "title": "阻止通知",
    "description": "欢迎使用 Catena-X 中易于使用的端到端业务合作伙伴证书管理交换解决方案。",
    "recentNotifications": "最近的通知",
    "totalAffected": "受影响部位总数",
    "top5": "前 5 名交易所合作伙伴",
    "sendNotifications": "发送封锁通知",
    "sendUpdate": "发送更新",
    "sentHistory": "发送通知历史记录",
    "receivedHistory": "收到的通知历史记录",
    "sendDescription": "在 Catena-X 网络中创建并共享您的站点证书",
    "learnMore": "了解有关阻止通知的更多信息",
    "filters": {
      "lastYear": "过去 1 年",
      "sixMonths": "6个月",
      "threeMonths": "3个月",
      "oneMonth": "1个月",
      "lastWeek": "上星期",
      "selectDateRange": "选择日期范围",
      "bpnOrCompany": "业务伙伴编号或公司名称"
    },
    "stats": {
      "totalAffectedParts": "受影响部位总数",
      "topExchangePartners": "前 {count} 个 Exchange 合作伙伴",
      "sentNotifications": "已发送通知",
      "receivedNotifications": "收到通知"
    },
    "sentHistoryDescription": "使用该区域来管理来自合作伙伴的证书数据请求。",
    "receivedHistoryDescription": "查看和管理从合作伙伴收到的阻止通知。",
    "table": {
      "conversationName": "对话名称",
      "problemId": "问题ID",
      "partner": "伙伴",
      "bpn": "BPN 号码",
      "createdAt": "创建于",
      "partnerName": "合作伙伴名称",
      "sentBy": "发送者",
      "sentOn": "发送于",
      "receivedOn": "收到于"
    },
    "errors": {
      "fetchSentNotifications": "无法获取已发送的通知",
      "fetchStatistics": "无法加载通知统计信息",
      "fetchRecentNotifications": "无法加载最近的通知",
      "invalidDateRange": "无法获取没有有效日期范围的统计信息",
      "sendNotificationFailed": "发送阻止通知失败。",
      "validationFailed": "请填写所有必填字段"
    },
    "confirmationText": "我了解并确认我已正确填写所有必填信息。",
    "validityDisclaimer": "T-Systems 不会检查此处填写的元数据信息的有效性。",
    "generalInformation": "一般信息",
    "jobName": "职位名称",
    "jobNamePlaceholder": "输入职位名称",
    "receiverBpn": "接收器BPN",
    "expectedResponseBy": "预期回应",
    "success": {
      "notificationSent": "阻止通知发送成功",
      "notificationUpdateSent": "阻止通知更新发送成功"
    },
    "groups": {
      "notificationInformation": "通知信息",
      "blockInformationItems": "块信息项 *",
      "partIdentification": "零件识别",
      "componentLevelContainment": "组件级遏制",
      "periodAndVolumeLevelContainment": "周期和音量级别控制",
      "deliveryInformation": "配送信息",
      "quantities": "数量",
      "sizeOfProductionLot": "生产批量大小",
      "numberOfPartsPerDeliveryNote": "每份交货单的零件数量",
      "numberOfPartsPerPackage": "每包零件数量",
      "locationInContainer": "容器中的位置（可选）"
    },
    "fields": {
      "problemId": "问题ID",
      "notificationStatus": "通知状态",
      "problemDescription": "问题描述",
      "updateReason": "更新原因",
      "catenaXId": "Catena-X ID",
      "blockStatus": "区块状态",
      "manufacturingLocationId": "制造地点 ID",
      "customerPartId": "客户零件 ID",
      "integrationLevel": "集成度",
      "localIdentifiers": "本地标识符",
      "key": "钥匙",
      "value": "价值",
      "orderNumber": "订单号",
      "deliveryNoteNumber": "交货单编号",
      "packageNumber": "包裹数量",
      "deliveryPlace": "交货地点",
      "productionDate": "生产日期",
      "deliveryDate": "交货日期",
      "quantity": "数量",
      "unit": "单元",
      "xPosition": "X 位置",
      "yPosition": "Y 轴位置",
      "smallLoadCarrierLayer": "小承载层"
    },
    "editNotification": "编辑通知",
    "importJson": {
      "title": "导入 JSON 文件",
      "description": "上传 JSON 文件以使用提供的数据自动填充表单。",
      "importButton": "从 JSON 导入",
      "dropFileHere": "将 JSON 文件拖放到此处",
      "selectFile": "选择文件",
      "import": "进口",
      "success": "已成功从 JSON 导入表单数据",
      "parseError": "解析 JSON 文件失败",
      "readError": "读取文件失败。"
    },
    "partPicker": {
      "button": "零件选择器",
      "title": "零件选择器",
      "description": "从您的提供商数据中选择数字孪生体，以自动填写封锁信息项目。",
      "addToForm": "添加到表单",
      "success": "已向表单添加 {count} 个封锁信息项目。",
      "error": "加载方面详情失败。请重试。"
    },
    "tooltips": {
      "problemDescription": "自由文本字段，提供必须阻止部件的信息。",
      "updateReason": "自由文本，描述为什么需要更新先前提供的损坏零件列表。",
      "catenaXId": "序列化零件或批次的完全匿名 Catena-X ID。",
      "blockStatus": "阻止通知中各个部分的状态。",
      "manufacturingLocationId": "组件交付的供应商地点的地址。"
    },
    "updateNotification": "更新通知",
    "notificationDetails": "通知详情",
    "howTo": {
      "description": "探索其他 Catena-X 成员公司的数据优惠目录。您可以发送和接收阻止通知。 ",
      "doc": "想了解更多有关阻止通知如何工作的信息吗？"
    }
  },
  "ecu": {
    "title": "电子控制单元（ECU）",
    "description": "欢迎查看 Catena-X 网络中 ECU 数据交换的易用概览。",
    "sentHistory": "已发送消息历史",
    "receivedHistory": "已接收消息历史",
    "sentHistoryDescription": "查看并管理发送给合作伙伴的ECU消息。",
    "receivedHistoryDescription": "查看并管理从合作伙伴接收的ECU消息。",
    "tiles": {
      "item_1": {
        "title": "发送消息",
        "description": "查看发送到 Catena-X 网络合作伙伴的 ECU 消息"
      },
      "item_2": {
        "title": "接收消息",
        "description": "接收来自 Catena-X 网络 ECU 合作伙伴的消息"
      },
      "item_3": {
        "title": "ECU 用户指南",
        "description": "了解 ECU 用例及其工作原理"
      },
      "item_4": {
        "title": "开发者文档",
        "description": "快速访问用于设置和管理 ECU 数据交换的 API"
      },
      "item_5": {
        "title": "ECU 资产",
        "description": "查看并搜索所有 ECU 资产"
      },
      "item_6": {
        "title": "ECU 过程日志",
        "description": "访问过程日志以实现透明度和事件管理"
      }
    },
    "howTo": {
      "description": "通过在 Catena-X 网络中为电子控制单元（ECU）提供自动化状态通知和反馈循环，构建具有韧性的供应链。",
      "doc": "想了解更多关于电子控制单元（ECU）消息机制如何工作的内容吗？"
    },
    "filters": {
      "senderBpn": "发送方 BPN",
      "receiverBpn": "接收方 BPN",
      "catenaXId": "Catena-X ID",
      "ecuId": "ECU ID",
      "catenaXSiteId": "Catena-X 站点 ID"
    },
    "table": {
      "conversationName": "会话名称",
      "senderBpn": "发送方 BPN",
      "receiverBpn": "接收方 BPN",
      "sentOn": "发送时间",
      "receivedOn": "接收时间"
    },
    "errors": {
      "fetchNotifications": "获取 ECU 通知失败"
    },
    "stats": {
      "total": "总计",
      "messagesPerCountry": "按国家分类的消息",
      "sentMessages": "已发送消息",
      "receivedMessages": "已接收消息",
      "technicalSpecifications": "技术规格",
      "connector": "连接器",
      "connectors": "连接器",
      "policies": "策略",
      "viewAllConnectors": "查看所有连接器",
      "viewAllPolicies": "查看所有策略"
    }
  },
  "qualityAlert": {
    "sendSuccess": "发送成功！",
    "sendAlert": "发送质量警报",
    "sendInvestigation": "发送质量调查",
    "updateSuccess": "成功更新了！",
    "updateAlert": "更新质量警报",
    "updateInvestigation": "更新质量调查",
    "acceptConfirmTitle": "接受质量警报",
    "acceptConfirmDesc": "单击“是”即表示您接受此质量警报并同意采取适当的措施。",
    "rejectConfirmTitle": "拒绝质量警报",
    "rejectConfirmDesc": "单击“是”即表示您拒绝此质量警报。"
  },
  "traceability": {
    "title": "可追溯性",
    "description": "欢迎使用易于使用的用于 Catena-X 数据交换的端到端可追溯性应用程序",
    "createQualityAlertOrInvestigation": "创建质量警报或调查",
    "learnMore": "了解有关可追溯性的更多信息",
    "recentIndustryCoreNotifications": "近期行业核心通知",
    "recentTraceabilityNotifications": "最近的可追溯性通知",
    "tabs": {
      "inbound": "入境",
      "outbound": "出境",
      "published": "已发表",
      "consumed": "已消耗"
    },
    "howTo": {
      "description": "了解其他 Catena-X 成员公司的数据提供目录。",
      "doc": "想了解更多关于数据报价协商和消费工作吗？"
    },
    "tiles": {
      "createOffer": {
        "title": "创建可追溯性报价",
        "description": "创建并与 Catena-X 网络参与者共享可追溯性数据"
      },
      "discoverData": {
        "title": "发现可追溯性数据",
        "description": "在 Catena-X 网络中搜索和协商可追溯性数据"
      },
      "notifications": {
        "title": "可追溯性通知",
        "description": "快速访问质量通知，例如质量警报和质量调查"
      },
      "industryCoreNotifications": {
        "title": "行业核心通知",
        "description": "查看数字孪生事件通知，例如子模型更新、反馈事件等"
      },
      "contractAgreements": {
        "title": "合同协议",
        "description": "查看所有提供和消耗的合同协议"
      },
      "exchangeHistory": {
        "title": "兑换历史",
        "description": "获得 Catena_X 网络和合作伙伴中的可追溯性数据交换历史的透明度",
        "uploadHistory": "上传历史记录",
        "downloadHistory": "下载历史记录"
      },
      "blockNotifications": {
        "title": "阻止通知",
        "description": "轻松快速地报告缺陷并向合作伙伴发送受影响部件的阻止通知。"
      }
    }
  },
  "useCases": {
    "ecu": {
      "title": "ECU",
      "description": "ECU消息传递"
    },
    "ecuTest": {
      "title": "ECU-TEST",
      "description": "不受业务伙伴限制的ECU消息传递"
    },
    "co2": {
      "title": "可持续发展与CO2足迹",
      "description": "可持续发展与CO2足迹"
    },
    "dcm": {
      "title": "业务伙伴数据管理",
      "description": "需求与产能管理 - 减少瓶颈，提高安全性"
    },
    "ce": {
      "title": "循环经济",
      "description": "循环经济 - 最大化资源利用"
    },
    "companyCertificates": {
      "title": "公司证书",
      "description": "简化公司证书的管理和交换流程，减少为不同客户维护多个证书的负担"
    },
    "bmwbp": {
      "title": "宝马电池护照",
      "description": "宝马电池护照"
    },
    "cyberSecurityKpi": {
      "title": "网络安全指标",
      "description": "简化网络安全KPI的管理和交换流程，减少为不同客户维护多个KPI的负担"
    },
    "traceability": {
      "title": "可追溯性",
      "description": "可追溯性是指在整个价值链中追踪实体零件和材料，以支持跨所有n层级的数据驱动用例，同时不损害数据主权"
    },
    "blockingNotifications": {
      "title": "阻塞通知",
      "description": ""
    },
    "batteryPassBmw": {
      "title": "电池护照（BMW）",
      "description": "BMW 电池护照——在电池供应链中最大化资源利用"
    },
    "modularProduction": {
      "title": "模块化生产",
      "description": "模块化生产"
    },
    "qualityManagement": {
      "title": "质量管理",
      "description": "质量管理"
    },
    "realTimeControl": {
      "title": "实时控制",
      "description": "实时控制"
    }
  },
  "certificateUpload": {
    "title": "证书",
    "pageTitle": "添加新证书",
    "cardTitle": "请上传您的证书文档以开始",
    "dragAndDrop": "将您的证书文件拖放到此处。",
    "supportedFiles": "支持的文件类型：.pdf",
    "invalidFileType": "仅支持 PDF 文件。",
    "fileTooLarge": "所选文件超过最大允许大小。",
    "supportedTypesLabel": "支持以下证书类型",
    "supportedTypesTooltip": "更多信息请参阅文档。",
    "continue": "继续",
    "remove": "移除",
    "preview": {
      "title": "证书预览",
      "subtitle": "原始上传文档",
      "emptyMessage": "上传后，您的证书预览将显示在此处。",
      "emptyTitle": "上传证书以在此处预览",
      "emptySubtitle": "上传 PDF 以在此处预览。",
      "fallback": "此浏览器不支持预览。",
      "openCertificate": "打开证书",
      "ariaLabel": "已上传证书的预览",
      "prevPage": "上一页",
      "nextPage": "下一页"
    },
    "processingMethod": {
      "title": "确认处理方式",
      "subtitle": "选择您希望如何录入证书信息",
      "fileSummary": "名称 example.pdf",
      "proceedWithAi": "使用 AI 继续",
      "recommended": "推荐",
      "continueManually": "手动继续",
      "proceedWithAiDescLine1": "我们的 AI 将自动从您上传的文档中提取证书信息并预填表单字段。",
      "continueManuallyDescLine1": "您可以使用表单手动输入证书信息。",
      "descLine2": "保存前您可以检查并编辑数据。"
    },
    "aiProcessing": {
      "title": "正在处理证书",
      "subtitle": "我们的 AI 正在从您的文档中提取信息",
      "analyzingTitle": "正在分析您的证书...",
      "completedTitle": "证书分析完成",
      "analyzingSubtitle": "这可能需要几秒钟",
      "errorSubtitle": "请重试分析",
      "didYouKnow": "您知道吗？",
      "expirationNotice": "当您的证书即将到期时，我们会自动通知您",
      "shareNotice": "您可以将正在上传的证书一次性分享给多个合作伙伴",
      "errorMessage": "我们无法分析您的证书。请重试。",
      "retry": "重试",
      "errors": {
        "extractionFailed": "我们无法分析您的证书。请重试。",
        "noFile": "未提供有效文件。请上传受支持的证书文件后重试。",
        "unsupportedFileType": "不支持的文件类型。请上传 PDF、JPEG 或 PNG 证书文件。",
        "invalidImage": "上传的图片无法处理。请上传清晰且受支持的图片。",
        "imageDimensionsExceeded": "上传的图片尺寸过大。请使用尺寸更小的图片。",
        "fileSizeExceeded": "上传的文件过大。请选择更小的证书文件。",
        "notCompanyCertificate": "上传的文档未被识别为公司证书。请上传有效的公司证书。",
        "invalidCertificateType": "该文档中的证书类型不受支持。",
        "certificateTextTooLong": "证书内容过长，无法处理。请上传更短或更精简的文档。",
        "processingTimeout": "文档处理超时。请重试。",
        "processingInterrupted": "文档处理被中断。请重试。",
        "noDataExtracted": "无法从该文档中提取证书数据。",
        "batchExtractionFailed": "处理文档页面时证书提取失败。请重试。",
        "aiResponseTruncated": "提取服务响应被截断。请稍后再试。",
        "processingFailed": "证书无法处理。请重试。",
        "pdfUnsupported": "此 PDF 包含不受支持的内容或结构。请上传其他 PDF。",
        "llmUnavailable": "AI 提取服务当前繁忙。请稍后重试。",
        "auth": "您无权执行证书提取。请重新登录。",
        "unavailable": "证书提取当前不可用。",
        "rateLimit": "提取请求过多。请稍后重试。",
        "fileReadFailed": "无法读取上传的文件。请重新上传文件后重试。",
        "serverError": "证书提取过程中发生服务器错误。请稍后重试。",
        "connectionTimeout": "请求耗时过长，连接已关闭。请重试——大型文档可能需要几分钟时间处理。"
      },
      "processingProgress": "处理中... 已完成 {percent}%",
      "steps": {
        "validating": "正在验证文档",
        "preparing": "正在准备文档",
        "extractingText": "正在提取文本内容",
        "convertingImages": "正在将页面转换为图像",
        "waitingLlm": "等待AI响应",
        "analyzing": "正在分析证书",
        "batchProgress": "页面批次 {done} / {total}",
        "merging": "正在完成结果"
      }
    },
    "review": {
      "title": "证书详情",
      "subtitle": "请检查下方所有已预填的数据",
      "successMessage": "证书数据提取成功。请根据需要检查并编辑。",
      "certificateName": "证书名称",
      "issuer": "签发方",
      "certificateId": "证书 ID",
      "ownerOrganization": "所属组织",
      "validFrom": "有效期开始",
      "validUntil": "有效期截止",
      "scope": "范围",
      "confirmation": "我确认输入的数据正确（占位文本）",
      "back": "返回",
      "save": "保存证书",
      "previewTitle": "证书预览",
      "previewSubtitle": "原始上传文档",
      "enclosedSitesSubtitle": "请选择该证书覆盖的 BPNA/BPNS 位置。",
      "aiConfirmation": "我同意并确认，AI 不对其填写的任何数据承担责任。",
      "aiNotice": "以下内容由 AI 填写。AI 可能会出错。请确保数据正确。",
      "metadataConfirmation": "我理解并确认我已正确填写所有必需信息；如信息有误并导致报价被拒，T-Systems 不承担责任。",
      "metadataNotice": "T-Systems 不会核验此处填写的元数据信息有效性。请确保填写的信息正确且完整。"
    }
  },
  "backendUnavailable": {
    "title": "服务暂时不可用",
    "subtitle": "后端服务当前不可访问。请检查您的连接或稍后再试。",
    "retryButton": "重试",
    "checking": "正在检查连接..."
  }
}
